import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadAccidentSegments
export default function RASContent() {

    const mapTooltip = useAppSelector(state => state.mapTooltip)
    const { roadAccidentSegmentTotalAccidentNumber, roadAccidentSegmentStatus } = mapTooltip ?? {}

    return (
        <>
            <div className="tooltip-info-row">Количество ДТП: {roadAccidentSegmentTotalAccidentNumber}</div>
            <div className="tooltip-info-row">Статус участка: {roadAccidentSegmentStatus}</div>
        </>
    )
}
